import styled from 'styled-components';

export type ButtonProps = {
	onClick: () => void;
	image: string;
	imageAlt?: string;
	imageSize?: number;
	imagePadding?: number;
	label?: string;
	disabled?: boolean;
	active?: boolean;
	Icon?: any;
};

function CustomButton({ onClick, image, label, imageAlt, imageSize, imagePadding, disabled, active, Icon }: ButtonProps) {
	return (
		<Button onClick={disabled ? undefined : onClick} aria-label={label} disabled={disabled}>
			{Icon ? (
				<Icon size={imageSize ?? 45} color={active ? '#e5b800' : 'white'} style={{ padding: imagePadding || '0', opacity: disabled ? 0.5 : 1 }} />
			) : (
				<ButtonImage src={image} alt={imageAlt} height={imageSize ?? 45} width={imageSize ?? 45} style={{ padding: imagePadding || '0', opacity: disabled ? 0.5 : 1 }} />
			)}
			{label && <ButtonLabel style={{ opacity: disabled ? 0.5 : 1 }}>{label}</ButtonLabel>}
		</Button>
	);
}

export default CustomButton;

const Button = styled.div<{ disabled?: boolean }>`
	margin: 0 5px;
	cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

const ButtonLabel = styled.p`
	margin: 0;
	padding: 0;
	font-size: 9px;
	text-transform: uppercase;
	font-weight: 900;
`;

const ButtonImage = styled.img`
	display: block;
	margin: 0 auto;
	padding: 0;
`;
